import React from "react";
import "./App.css";
import image from "./emma.jpg";

function App() {
  return (
    <div className="card">
      <div className="details">
        <img src={image} alt="A picture of Emmanuel" />
        <h2>Adekanbi Emmanuel</h2>
        <b>London, United Kingdom</b>
        <p>"Front-end developer and avid reader."</p>
      </div>
      <div className="social-links">
        <button>
          <a href="https://github.com/dynamic109">Github</a>
        </button>
        <button>
          <a href="https://www.frontendmentor.io/profile/dynamic109">
            Frontend Mentor
          </a>
        </button>
        <button>
          <a href="https://www.linkedin.com/in/dynamic109">LinkedIn</a>
        </button>
        <button>
          <a href="https://x.com/dynamic109">Twitter</a>
        </button>
        <button>
          <a href="https://x.com/dynamic109">Instagram</a>
        </button>
      </div>
    </div>
  );
}

export default App;
